import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { isFetchingSelector, fetchedSelector, errorSelector } from '../selectors/dashboardSelector';
import { getDashboardDataRequest, unloadDashboard } from '../actions/dashboardActions';
import Dashboard from '../components/Dashboard/Dashboard';

const mapStateToProps = createStructuredSelector({
    isFetching: isFetchingSelector,
    fetched: fetchedSelector,
    error: errorSelector
});

const mapDispatchToProps = {
    getDashboardDataRequest,
    unloadDashboard
};

export default connect(mapStateToProps, mapDispatchToProps)(Dashboard);
